<template>
    <div>
        <div v-if="this.isAdverseCustomPage == '0'" v-wechat-title="title" style="height: 100%">
            <crud-facecade ref="data-list" :url="url" :columns="columnList" :buttons="[]" dialogWidth="40%" :tableHeight="tableHeight" :deleteButton="{ enabled: true, permission: 'default' }">
            </crud-facecade>
            <!--新增不良事件-->
            <!-- <form-dialog  :title="title1" :visible.sync="saveEventView.dialogFormVisible"
    :data="saveEventView.data" :columns="saveEventViewColumns" width="40%" @confirm="confirm"></form-dialog> -->
        </div>
        <el-container v-else v-wechat-title="title" :style="{ height: this.screenHeight - 40 + 'px', position: 'relative' }">
            <el-main class="width-p100" style="padding: 10px; margin-left: 10px; height: 100%; background: white" v-loading="loading">
                <div v-if="refUrl" style="text-align: left">
                    <el-link v-if="isCustomProtocol || isblankWindow" :href="refUrl" target="_blank" type="primary"><i class="el-icon-link"></i>点击链接:{{ this.title }}</el-link>
                    <iframe v-else frameborder="0" scrolling="auto" :src="refUrl" :height="this.screenHeight - 40" width="100%"></iframe>
                </div>
                <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5">
                    <span class="el-icon-document"></span>
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `Adverse`,
    data() {
        return {
            title: `不良事件`,
            saveEventView: {
                dialogFormVisible: false,
                data: {}
            },
            title1: `创建`,
            event_group: [],
            event_detail: [],
            dic_ward_id: undefined,
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            _isBlankWindow: false,
            url: {
                area: `adversehappen`,
                baseURL: `api/Nursing/AdverseEventHappen`,
                get: () => {
                    return this.loadEvents()
                },
                post: row => {
                    return this.saveEvent(row, `post`)
                },
                put: row => {
                    return this.saveEvent(row, `put`)
                }
            },
            refUrl: this.$root.AdverseRefUrl,
            loading: false,
            surgeryInfo: {},
            visitInfo: {},
            isAdverseCustomPage: this.$root.IsAdverseCustomPage,
            showAdverseEventStatus: this.$root.ShowAdverseEventStatus && this.$root.ShowAdverseEventStatus == `1`,
            active_ward_id: null,
            eventStatus: [
                { label: `已驳回`, value: -1 },
                { label: `未处理`, value: 0 },
                { label: `已上报`, value: 1 },
                { label: `已审核`, value: 2 }]
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `currentUser`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 180) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `adverse_type`,
                    label: `属性`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `group_name`,
                    label: `事件类型`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件名称`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `event_status`,
                    label: `状态`,
                    width: `80`,
                    options: this.eventStatus,
                    isListable: this.showAdverseEventStatus
                },
                {
                    type: `string`,
                    prop: `case_type`,
                    label: `病例类型`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `occur_time`,
                    label: `发生时间`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `modify_date`,
                    label: `报告时间`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `报告人`,
                    isListable: true
                }
            ].concat(this.saveEventViewColumns)
            // {
            //   type: "buttongroup",
            //   prop: "oper",
            //   label: "操作",
            //   width: "260",
            //   isListable: true,
            //   readonly:false,
            //   options:[{
            //           class:"is-plain",
            //           label: "编辑",
            //           icon:"",
            //           type: "primary",
            //           emit: "saveEvent",
            //           permission: "default"
            //         },{
            //           class:"is-plain",
            //           label: "删除",
            //           icon:"",
            //           type: "danger",
            //           emit: "deleteEvent",
            //           permission: "default"
            //         }]
            //     }
        },
        saveEventViewColumns() {
            return [
                {
                    type: `radio`,
                    prop: `enum_event_type`,
                    label: `事件属性`,
                    options: this.sys_enums.AdverseEventType || [],
                    colspan: 24,
                    default: 1,
                    isEditable: true,
                    isCreatable: true,
                    change: (that, { row }) => {
                        row.dic_adverse_category_id = undefined
                        row.enum_event_grade = undefined
                        row.dic_adverse_event_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `dic_adverse_category_id`,
                    label: `事件类型`,
                    options: (that, { row }) => {
                        return _.filter(this.event_group, { enum_adverse_type: row.enum_event_type })
                    },
                    colspan: 12,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: null,
                    change: (that, { row }) => {
                        row.dic_adverse_event_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `anesthesia_time_stage`,
                    label: `麻醉时间分段`,
                    options: (that, { row }) => {
                        return [{ label: `麻醉前`, value: `麻醉前` },
                            { label: `手术中`, value: `手术中` },
                            { label: `手术后`, value: `手术后` }]
                    },
                    colspan: 12,
                    isEditable: this.showAdverseEventStatus,
                    isCreatable: this.showAdverseEventStatus,
                    default: null
                },
                {
                    type: `select`,
                    prop: `dic_adverse_event_id`,
                    label: `事件名称`,
                    options: (that, { row }) => {
                        return _.filter(this.event_detail, { dic_adverse_category_id: row.dic_adverse_category_id })
                    },
                    colspan: this.showAdverseEventStatus ? 24 : 12,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: null
                },
                {
                    type: `select`,
                    prop: `enum_event_grade`,
                    label: `不良反应等级`,
                    colspan: 12,
                    options:
                        _.filter(this.sys_enums.AdverseEventChartType, d => {
                            return d.value != 0
                        }) || [],
                    readonly: function(that, { row }) {
                        return row.enum_event_type !== 1
                    },
                    isEditable: true,
                    isCreatable: true,
                    default: 1
                },
                {
                    type: `datetime`,
                    prop: `occur_time`,
                    label: `发生时间`,
                    colspan: 12,
                    isEditable: true,
                    isCreatable: true,
                    default: this.$moment().format(`YYYY/MM/DD HH:mm`)
                },
                {
                    type: `string`,
                    prop: `place`,
                    label: `发生场所`,
                    colspan: 12,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `select`,
                    prop: `enum_case_type`,
                    label: `病例类型`,
                    colspan: 12,
                    options: this.sys_enums.Enum_CaseType || [],
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `string`,
                    prop: `present`,
                    label: this.T(`adverseEvent.present`),
                    colspan: 12,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `string`,
                    prop: `adverse_consequence`,
                    label: `不良后果`,
                    colspan: 12,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `说明`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `textarea`,
                    prop: `event_declaration`,
                    label: `事件经过`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `textarea`,
                    prop: `cause`,
                    label: `原因分析`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `textarea`,
                    prop: `measure`,
                    label: `处置措施`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `string`,
                    prop: `consequence`,
                    label: `结果`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    default: null
                },
                {
                    type: `p`,
                    prop: `modifier`,
                    label: `报告人`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    default: this.currentUser && this.currentUser.dic_worker_name
                }
            ]
        },
        isCustomProtocol() {
            return !_.startsWith(this.refUrl, `http`)
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            //  加载所有枚举
            this.$store.dispatch(`enums/ADD_ALL_ENUM`)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.loadSurgery()
    },
    mounted() {},
    methods: {
        loadEvents() {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve([])
                    return
                }
                let that = this
                let req = that.myaxios.get(`/api/Nursing/AdverseEventHappen/GetBySurgery?surgeryId=${this.surgeryId}&&stype=1`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {
                            id: d.id,
                            patient_name: d.surgery_info && d.surgery_info.visit_info && d.surgery_info.visit_info.name,
                            visit_no: d.surgery_info && d.surgery_info.visit_info && d.surgery_info.visit_info.visit_no,
                            event_type: d.event_type,
                            group_name: d.dic_adverse_event && d.dic_adverse_event.group_name,
                            name: d.dic_adverse_event && d.dic_adverse_event.name,
                            occur_time: this.$moment(d.occur_time).format(`YYYY/MM/DD HH:mm`),
                            modify_date: this.$moment(d.modify_date).format(`YYYY/MM/DD HH:mm`),
                            modifier: d.modifier,
                            event_grade: d.event_grade,
                            consequence: d.consequence,
                            adverse_consequence: d.adverse_consequence,
                            present: d.present,
                            cause: d.cause,
                            measure: d.measure,
                            event_declaration: d.event_declaration,
                            place: d.place,
                            adverse_type: d.dic_adverse_event && d.dic_adverse_event.adverse_type,
                            dic_adverse_event_id: d.dic_adverse_event_id,
                            enum_event_type: d.dic_adverse_event && d.dic_adverse_event.enum_adverse_type,
                            enum_event_grade: d.enum_event_grade,
                            dic_adverse_category_id: d.dic_adverse_event && d.dic_adverse_event.dic_adverse_category_id,
                            enum_case_type: d.enum_case_type,
                            case_type: d.case_type,
                            event_status: d.event_status,
                            anesthesia_time_stage: d.anesthesia_time_stage,
                            remark: d.remark
                        }
                    })
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
            })
        },
        loadDicAdverse() {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/AdverseEvent/Get`)
                let req1 = this.myaxios.get(`/api/AcisSystem/AdverseCategory/Get`)
                this.myaxios
                    .all(req, req1)
                    .then(([data, data1]) => {
                        _.forEach(data1, r => {
                            r.dic_ward_ids =
                                (r.regions &&
                                    r.regions.map(d => {
                                        return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`)
                                    })) ||
                                []
                        })
                        if (that.active_ward_id && that.active_ward_id != `ow_0`) {
                            data1 = _.filter(data1, function(d) {
                                return !d.dic_ward_ids || d.dic_ward_ids.length == 0 || _.includes(d.dic_ward_ids, that.active_ward_id)
                            })
                        } else {
                            // 未获取到对应区域 取当前手术的手术区和复苏室 Dic_OperatingWard_Id Dic_RecoveryWard_Id
                            data1 = _.filter(data1, function(d) {
                                return (
                                    !d.dic_ward_ids ||
                                    d.dic_ward_ids.length == 0 ||
                                    _.includes(d.dic_ward_ids, `ow_${that.surgeryInfo.dic_operating_ward_id}`) ||
                                    _.includes(d.dic_ward_ids, `rw_${that.surgeryInfo.dic_recovery_ward_id}`)
                                )
                            })
                        }
                        this.event_group = _.filter(data1, { is_deleted: false }).map(d => {
                            return {
                                value: d.id,
                                label: d.name,
                                jianpin: d.abbr,
                                enum_adverse_type: d.enum_adverse_type
                            }
                        })
                        this.event_detail = _.filter(data, { is_deleted: false }).map(d => {
                            return {
                                value: d.id,
                                label: d.name,
                                jianpin: d.abbr,
                                code: d.group_name,
                                dic_adverse_category_id: d.dic_adverse_category_id
                            }
                        })
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        currentEmrRefUrl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
                console.log(refUrl)
            }
            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            this.refUrl = refUrl
            return this.refUrl
        },
        isblankWindow() {
            let blankWindows = this.$root.isBlankWindow
            let config = JSON.parse(blankWindows)
            if (config && config.isblank) {
                let blankPages = config.blankPages
                let index = _.indexOf(blankPages, this.title)

                if (index >= 0) {
                    this._isBlankWindow = true
                }
            } else {
                this._isBlankWindow = false
            }
            console.log(this._isBlankWindow)
            return this._isBlankWindow
        },
        // saveEvent({row}){
        //   this.title1 = '编辑'
        //   this.saveEventView.data = row
        //   if(!row){
        //     this.saveEventView.data = {occur_time:this.$moment().format("YYYY/MM/DD HH:mm")}
        //   }
        //   this.saveEventView.dialogFormVisible = true
        // },
        saveEvent(row, type) {
            let data = {
                id: row.id,
                enum_event_type: row.enum_event_type,
                dic_adverse_event_id: row.dic_adverse_event_id,
                enum_event_grade: row.enum_event_grade,
                occur_time: row.occur_time,
                place: row.place,
                event_declaration: row.event_declaration,
                cause: row.cause,
                measure: row.measure,
                consequence: row.consequence,
                adverse_consequence: row.adverse_consequence,
                present: row.present,
                biz_surgery_info_id: this.surgeryId,
                enum_case_type: row.enum_case_type,
                anesthesia_time_stage: row.anesthesia_time_stage,
                remark: row.remark
            }
            return this.myaxios[type](`/api/Nursing/AdverseEventHappen/${type}`, data)
            // if(this.saveEventView.data.id === undefined){
            //   req = this.myaxios.post(`/api/Nursing/AdverseEventHappen/Post`,data)
            // }else{
            //   req = this.myaxios.put(`/api/Nursing/AdverseEventHappen/Put`,data)
            // }
            // req.then(data=>{
            //   this.$refs["data-list"].ReloadListData()
            //   this.saveEventView.dialogFormVisible = false
            // }).catch(e=>{
            //   console.log(e)
            // })
        },
        isjson(jsonstr) {
            if (typeof jsonstr == `string`) {
                try {
                    var obj = JSON.parse(jsonstr)
                    if (typeof obj == `object` && obj) {
                        return true
                    } else {
                        return false
                    }
                } catch (e) {
                    return false
                }
            }
            return false
        },
        loadSurgery() {
            if (!this.surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(
                        data.extra_datas,
                        function(result, value, index) {
                            let flag = that.isjson(value.DataValue)
                            if (value.DataValue != `` && flag == true) {
                                result[value.DataKey] = value.DataExtraValue
                            } else {
                                result[value.DataKey] = value.DataValue
                            }
                            return result
                        },
                        {}
                    )
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                })
                .then(data => {
                    this.currentEmrRefUrl()
                    that.active_ward_id = this.active_ward && this.active_ward.value
                    that.loadDicAdverse()
                })
                .then(data => {
                    let blankWin = this.isblankWindow()
                    if (blankWin && this.surgeryId && this.refUrl.indexOf(`@`) == -1) {
                        window.open(this.refUrl)
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        }
        // deleteEvent({row,index}){
        //   console.log(row)
        //   this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'warning'
        //     }).then(() => {
        //         let req = this.myaxios.delete(`/api/Nursing/AdverseEventHappen/Delete?id=${row&&row.id}`)
        //         req.then(data=>{
        //           this.$refs["data-list"].ReloadListData()
        //         }).catch(e=>{
        //           console.log(e)
        //         })
        //     })
        // }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.$refs[`data-list`].ReloadListData()
            this.loadSurgery()
        }
        // active_ward: function(newVal, oldVal) {
        //     this.active_ward_id = newVal && newVal.value
        //     this.loadDicAdverse()
        // }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Adverse/Index.vue